import { SET_ENABLE_MY_CARS } from '../actions/types';

const initialState = false;

export default function enableMyCars(state = initialState, action) {
	switch (action.type) {
		case SET_ENABLE_MY_CARS:
			return action.payload;
		default:
			return state;
	}
}
